// Bootstrap breakpoints: https://getbootstrap.com/docs/4.3/layout/overview/#responsive-breakpoints
export enum WindowBreakpoint {
  Small = 576,
  Medium = 768,
  Large = 992,
  ExtraLarge = 1200,
}
